import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { CurlyBracesIcon } from '../CurlyBracesIcon';
import styles from './VariableFieldAdornment.module.scss';
export const GetVariableFieldAdornmentTID = (parentTestId)=>getTestIds(parentTestId);
export function VariableFieldAdornment(param) {
    let { onClick, disabled, testId } = param;
    const { VariableFieldAdornmentTestIds } = useMemo(()=>GetVariableFieldAdornmentTID(testId), [
        testId
    ]);
    const { t: templateVariablesTexts } = useLocaleKeys('components.templateVariables');
    if (disabled) {
        return null;
    }
    return /*#__PURE__*/ _jsx("button", {
        type: "button",
        className: styles.adornmentButton,
        onMouseDown: (e)=>e.preventDefault(),
        onClick: (e)=>{
            e.stopPropagation();
            onClick();
        },
        "aria-label": templateVariablesTexts.insertButton(),
        "aria-haspopup": "dialog",
        "data-testid": VariableFieldAdornmentTestIds.Root(),
        children: /*#__PURE__*/ _jsx(CurlyBracesIcon, {
            className: styles.bracesIcon
        })
    });
}
